module.exports = __webpack_public_path__ + "assets/img/script_props_default.0c5f50f1.jpg";